import { cn, getAccessibleTextColor } from '@risksmart-app/atomic-ui';

type PreviewCellProps = {
  color?: string;
  label: string;
  value?: number | string;
  className?: string;
  valueClassName?: string;
};

const PreviewCell = ({
  color,
  label,
  value,
  className,
  valueClassName,
}: PreviewCellProps) => {
  const textColor = color ? getAccessibleTextColor(color) : undefined;

  return (
    <div
      data-slot={'preview-cell'}
      className={cn(
        'flex flex-col items-center justify-center rounded-lg px-1.5 py-1 text-center h-9 gap-0.5',
        !color && 'bg-primary-hover text-primary-foreground',
        className
      )}
      style={color ? { backgroundColor: color, color: textColor } : undefined}
    >
      <span
        className={cn('text-sm font-semibold leading-tight whitespace-nowrap')}
      >
        {label}
      </span>
      {value !== undefined && (
        <span
          className={cn('text-xs font-semibold leading-none', valueClassName)}
        >
          {value}
        </span>
      )}
    </div>
  );
};

export { PreviewCell };
